export const getPermissionErrorName = (
  hasAudioPermissions: boolean,
  hasVideoPermissions: boolean,
) => {
  if (hasAudioPermissions && !hasVideoPermissions) {
    return "micCamCheck:cam.needs.permission";
  }
  if (!hasAudioPermissions && hasVideoPermissions) {
    return "micCamCheck:mic.needs.permission";
  }
  return "micCamCheck:both.needs.permission";
};

export const getPermissionDeviceSubstring = (
  hasBlockedAudioPermissions: boolean,
  hasBlockedVideoPermissions: boolean,
) =>
  // eslint-disable-next-line no-nested-ternary
  hasBlockedAudioPermissions && hasBlockedVideoPermissions
    ? "both"
    : hasBlockedVideoPermissions
    ? "cam"
    : "mic";
